import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-policy-sumary-consent',
  templateUrl: './policy-sumary-consent.component.html',
  styleUrls: ['./policy-sumary-consent.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class PolicySumaryConsentComponent implements OnInit {

  public title: string;
  public content: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.title = data.title;
    this.content = data.content;
  }

  ngOnInit(): void {
  }

}
